import { call, put, select, takeLatest } from 'redux-saga/effects';
import { salesOrganizationActions as actions } from '.';
import { selectErpSystem } from '../../erpSystem/slice/selectors';
import { SalesOrganization } from './types';

export function* fetchSalesOrganization() {
  const { getSalesOrganizationSuccess, getSalesOrganizationFail } = actions;
  try {
    const salesOrganizationResponse = yield call(
      fetch,
      '/gasket-configurator/api/salesOrganisations',
    );
    if (salesOrganizationResponse.status !== 200) {
      return yield put(getSalesOrganizationFail('failed to fetch'));
    } else {
      const salesOrganizations: SalesOrganization[] =
        yield salesOrganizationResponse.json();
      const erpSystem = yield select(selectErpSystem);
      const salesOrganizationOfErpSystem: SalesOrganization | undefined =
        salesOrganizations.find(org => org.country === erpSystem);
      if (!salesOrganizationOfErpSystem) {
        return yield put(
          getSalesOrganizationFail('no sales organization for erp system'),
        );
      }
      return yield put(
        getSalesOrganizationSuccess(salesOrganizationOfErpSystem),
      );
    }
  } catch (e) {
    yield put(getSalesOrganizationFail(e));
  }
}

export function* salesOrganizationSaga() {
  yield takeLatest(actions.getSalesOrganization.type, fetchSalesOrganization);
}
